import React from "react";

export const SpecialOffer = () => {
  return (
    <>
   <div className="bg-gray-50 py-8">
  <div className="max-w-7xl mx-auto px-6">
    <div className="relative rounded mt-4">
      <div className="grid sm:grid-cols-2 grid-cols-1 items-center gap-8 sm:gap-10 py-10 border-y-8 border-orange-400">
        {/* Text Section */}
        <div className="text-center sm:text-left px-6">
          <h3 className="font-extrabold text-4xl sm:text-5xl text-orange-500 leading-tight">
            <span className="text-gray-800">Limited-Time</span> Offer
          </h3>
          <h6 className="text-xl sm:text-2xl text-gray-800 mt-2">Be Among the First 10 Students to Save Big
          </h6>
          <p className="text-gray-800 text-base sm:text-lg leading-relaxed mb-6 mt-4">
          Enroll now and get an exclusive 20% discount on your course fee. Don’t miss this chance to kickstart your IT journey!

          </p>
          <a href="/contact"
            
            className="bg-gradient-to-r hover:bg-gradient-to-l from-orange-400 to-orange-600 hover:bg-orange-500 text-white tracking-wide font-semibold text-sm sm:text-base py-3 px-6 rounded-lg w-max "
          >
            Get Started
          </a>
        </div>

        {/* Image Section */}
        <div className="flex justify-center sm:justify-end">
          <div className="bg-gradient-to-tr w-full from-orange-400 to-orange-600 rounded-tl-full rounded-bl-full p-4 sm:p-6">
            <img
              src="https://readymadeui.com/team-image.webp"
              className="h-48 w-48 sm:h-64 sm:w-64 rounded-full object-cover border-4 border-white"
              alt="brain Box Study"
            />
          </div>
        </div>
      </div>

      {/* Decorative Circles */}
      <div className="absolute top-[10px] left-[0px] w-20 sm:w-28 h-20 sm:h-28 rounded-full bg-[#d68c21] opacity-40 shadow-lg"></div>
      <div className="absolute top-10 -left-10 w-20 sm:w-28 h-20 sm:h-28 rounded-full bg-amber-700 opacity-40 shadow-lg"></div>
      <div className="absolute bottom-[15px] sm:bottom-[20px] lg:left-[45%] lg:translate-x-[-50%] w-20 sm:w-28 h-20 sm:h-28 rounded-full bg-[#d68c21] opacity-40 shadow-lg"></div>
      <div className="absolute bottom-10 sm:bottom-12 lg:left-[47%] lg:translate-x-[-50%] w-20 sm:w-28 h-20 sm:h-28 rounded-full bg-amber-700 opacity-40 shadow-lg"></div>
    </div>
  </div>
</div>

    </>
  );
};
